<template>
    <div class="form-selection-panel mt-3 max-h-48 overflow-y-auto">
        <label
            v-for="company in companies"
            :key="company.id"
            class="form-selection-option flex cursor-pointer items-center px-3 py-2"
        >
            <input
                :checked="selectedIds.includes(Number(company.id))"
                class="form-checkbox mr-3 h-4 w-4 flex-shrink-0 text-gray-700"
                type="checkbox"
                @change="toggle(company.id, $event.target.checked)"
            >
            <img
                :alt="company.name"
                :src="company.image || '/images/default/icon.png'"
                class="mr-3 h-6 w-6 flex-shrink-0 rounded-sm object-cover"
            >
            <span class="truncate text-sm text-gray-700">{{ company.name }}</span>
        </label>
        <div v-if="companies.length < 1" class="px-3 py-2 text-sm text-gray-500">
            {{ emptyText }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'relationship-company-selection',
    props: {
        modelValue: {
            type: Array,
            default: () => [],
        },
        companies: {
            type: Array,
            default: () => [],
        },
        emptyText: {
            type: String,
            default: 'Keine Unternehmen verfügbar.',
        },
    },
    emits: ['update:modelValue'],
    computed: {
        selectedIds() {
            return this.modelValue.map((id) => Number(id));
        },
    },
    methods: {
        toggle(companyId, checked) {
            const id = Number(companyId);
            const ids = this.selectedIds.filter((selectedId) => selectedId !== id);
            if (checked) {
                ids.push(id);
            }
            this.$emit('update:modelValue', ids);
        },
    },
};
</script>
